import { createVisionAiApiClient } from "./VisionAiApiClient";

export type { VisionAiApiClient } from "./VisionAiApiClient";

export const visionAiApiClient = createVisionAiApiClient();

export const {
	platform: platformApi,
	grader: graderApi,
	configurator: configuratorApi,
	cms: cmsApi,
	urlShortener: urlShortenerApi,
	registerGetAccessToken,
} = visionAiApiClient;
